import { QueryParameters as NonPersonalizedQueryParams } from "@faire/web-api--source/api/v2/categories/navigation/get";
import { QueryParameters as PersonalizedQueryParams } from "@faire/web-api--source/api/v2/categories/personalized/retailerToken/navigation/get";
export var buildNonPersonalizedQueryParams = function(param) {
    var clientPlatformType = param.clientPlatformType, navigationTreeHashCode = param.navigationTreeHashCode, locale = param.locale, country = param.country;
    return NonPersonalizedQueryParams.build({
        clientPlatformType: clientPlatformType,
        hashCode: navigationTreeHashCode,
        locale: locale,
        country: country
    });
};
export var buildPersonalizedQueryParams = function(param) {
    var clientPlatformType = param.clientPlatformType, navigationTreeHashCode = param.navigationTreeHashCode, locale = param.locale;
    return PersonalizedQueryParams.build({
        clientPlatformType: clientPlatformType,
        hashCode: navigationTreeHashCode,
        locale: locale
    });
};
